export default __webpack_public_path__ + "static/guerrilla_l2-029071600234bc467658b6e6ddb41b04.jpg";